import * as React from "react";

import { Button } from "@blueprintjs/core";
import { Set } from "immutable";
import { IModerationOption } from "~/graphql/queries/optionApproval/optionsPendingApproval";
import MainLayout from "~/layouts/MainLayout";
import styled from "~/styled";
import ProblemReporterButton from "../ProblemReporterButton";
import ApprovalOption from "./ApprovalOption";

const Grid = styled.div`
  display: grid;
  grid-gap: 12px;
  grid-template-columns: repeat(auto-fill, 300px);
`;

interface IProps {
  moderationOptions: IModerationOption[];
  approvedIds: Set<string>;
  rejectedIds: Set<string>;
  onApprove: (moderationOptionId: string) => void;
  onReject: (moderationOptionId: string) => void;
  onSubmit: () => void;
  onBulkToggle: () => void;
}

export default class ProductOptionApprovalForm extends React.Component<IProps> {
  public render() {
    const {
      moderationOptions,
      onApprove,
      onReject,
      approvedIds,
      rejectedIds
    } = this.props;

    return (
      <MainLayout
        title={
          <h3>
            Click an image to toggle it's approval status. Reject all images
            that have logos, watermarks, backgrounds, promotional content,
            discounts, quantity, text or shop name.
          </h3>
        }
        actions={
          <React.Fragment>
            <Button large={true} intent="success" onClick={this.handleSubmit}>
              Save and next
            </Button>
            <Button large={true} intent="none" onClick={this.handleBulkToggle}>
              Toggle all
            </Button>
            <ProblemReporterButton />
          </React.Fragment>
        }
      >
        <Grid>
          {moderationOptions.map(moderationOption => (
            <ApprovalOption
              key={moderationOption.id}
              isApproved={approvedIds.contains(moderationOption.id)}
              isRejected={rejectedIds.contains(moderationOption.id)}
              moderationOption={moderationOption}
              onApprove={onApprove}
              onReject={onReject}
            />
          ))}
        </Grid>
      </MainLayout>
    );
  }

  private handleBulkToggle = (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();

    this.props.onBulkToggle();
  };

  private handleSubmit = (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();

    this.props.onSubmit();
  };
}



// WEBPACK FOOTER //
// ./src/components/ProductOptionApproval/ProductOptionApprovalForm.tsx